<template>
    <transition name="panel-slide">
        <div v-if="open" class="announcements-panel elevation-8">
            <div class="panel-header d-flex align-center justify-space-between pa-4">
                <div class="d-flex align-center ga-2">
                    <v-icon size="20" color="primary">mdi-bullhorn-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">Updates & Offers</span>
                    <v-chip v-if="store.unreadCount" color="primary" size="x-small" variant="tonal">
                        {{ store.unreadCount }}
                    </v-chip>
                </div>
                <v-btn icon size="small" variant="text" @click="$emit('close')">
                    <v-icon size="18">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-divider/>

            <div class="panel-body pa-3">
                <div v-if="store.loading && !store.messages.length" class="text-center pa-6">
                    <v-progress-circular indeterminate color="primary" size="32"/>
                </div>

                <div v-else-if="!store.messages.length" class="empty-state text-center pa-8">
                    <v-icon size="48" color="grey-lighten-1">mdi-inbox-outline</v-icon>
                    <div class="text-body-2 text-medium-emphasis mt-3">
                        Nothing new right now. Check back later!
                    </div>
                </div>

                <AnnouncementCard
                    v-for="msg in unreadMessages"
                    :key="msg.id"
                    :message="msg"
                    @click="store.markRead(msg.id)"
                    @dismiss="store.markRead(msg.id)"
                />

                <template v-if="readMessages.length">
                    <v-divider v-if="unreadMessages.length" class="my-2"/>
                    <div v-if="unreadMessages.length"
                         class="text-caption text-medium-emphasis text-center mb-2">Already read</div>
                    <div class="read-section">
                        <AnnouncementCard
                            v-for="msg in readMessages"
                            :key="msg.id"
                            :message="msg"
                            @click="store.markRead(msg.id)"
                            @dismiss="store.markRead(msg.id)"
                        />
                    </div>
                </template>
            </div>
        </div>
    </transition>
</template>

<script setup>
import {computed} from 'vue';
import {useAnnouncementsStore} from '@/stores/announcementsStore';
import AnnouncementCard from './AnnouncementCard.vue';

defineProps({open: {type: Boolean, default: false}});
defineEmits(['close']);

const store = useAnnouncementsStore();

const unreadMessages = computed(() => store.messages.filter(m => !m.is_read));
const readMessages = computed(() => store.messages.filter(m => m.is_read));
</script>

<style scoped>
.announcements-panel {
    position: fixed;
    top: 64px;
    right: 16px;
    width: 340px;
    max-height: calc(100vh - 80px);
    background: white;
    border-radius: 12px;
    z-index: 2000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.panel-header {
    flex-shrink: 0;
}

.panel-body {
    overflow-y: auto;
    flex-grow: 1;
}

.panel-slide-enter-active,
.panel-slide-leave-active {
    transition: opacity 0.2s ease, transform 0.25s ease;
}

.panel-slide-enter-from,
.panel-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px) scale(0.97);
}

.read-section {
    opacity: 0.55;
}
</style>
